import { render, staticRenderFns } from "./SelectSizeStep.vue?vue&type=template&id=5f674290&scoped=true&"
import script from "./SelectSizeStep.vue?vue&type=script&lang=js&"
export * from "./SelectSizeStep.vue?vue&type=script&lang=js&"
import style0 from "./SelectSizeStep.vue?vue&type=style&index=0&id=5f674290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f674290",
  null
  
)

export default component.exports